import './_price-filter.scss';
import component from './price-filter';

export default component;
